/**
 * Fehlercode des Ads-Verbindens -> i18n-Schluessel im Namensraum `adsPerformance`.
 *
 * Liegt in `lib/` und nicht in einer der beiden Komponenten, weil es ZWEI Wege
 * gibt, auf denen derselbe Code beim Nutzer ankommt, und beide dieselbe
 * Uebersetzung treffen muessen:
 *
 *   1. Popup-Fall: `google-oauth-handler` antwortet, `GoogleCallback` schickt
 *      `{ type: 'GOOGLE_ADS_OAUTH_ERROR', code }` per `postMessage` an
 *      `ConnectGoogleAdsButton`.
 *   2. Vollbild-Fall (Popup blockiert): `GoogleCallback` leitet auf
 *      `/internal/ads-performance?adsOauth=error&code=…` weiter, und das Panel
 *      muss den Code selbst aufloesen. Der Kommentar dort sagt es woertlich:
 *      "der Code reist als Parameter mit, damit dort nicht geraten werden muss".
 *
 * Zwei abgeschriebene Tabellen wuerden genau dann auseinanderlaufen, wenn ein
 * neuer Code dazukommt -- und dann saehe ausgerechnet der seltenere Pfad die
 * Sammelmeldung.
 *
 * Muster `src/lib/oauthError.ts`: kein Default in der Tabelle, der Aufrufer
 * waehlt ihn.
 */
export const ADS_ERROR_KEYS: Readonly<Record<string, string>> = {
  ADS_NO_REFRESH_TOKEN: 'connect.errors.noRefreshToken',
  ADS_SCOPE_MISSING: 'connect.errors.scopeMissing',
  ADS_NO_MATCHING_GOOGLE_ACCOUNT: 'connect.errors.noMatchingGoogleAccount',
  ADS_DEVELOPER_TOKEN_MISSING: 'connect.errors.developerTokenMissing',
  ADS_NO_ACCESSIBLE_CUSTOMERS: 'connect.errors.noAccessibleCustomers',
  ADS_LIST_CUSTOMERS_FAILED: 'connect.errors.listCustomersFailed',
};

/**
 * Der Schluessel zu einem Code, sonst die Sammelmeldung.
 *
 * Die Suche laeuft ueber `hasOwnProperty` und nicht ueber `ADS_ERROR_KEYS[code]`:
 * sonst liefert `code = 'toString'` ein geerbtes `Object.prototype`-Mitglied
 * (eine Funktion), `t()` bekommt keinen String und der Nutzer sieht eine leere
 * Meldung statt einer Erklaerung. Der Code kommt aus einem Query-Parameter, ist
 * also frei waehlbar.
 */
export function adsErrorKey(code: unknown): string {
  if (typeof code !== 'string') return 'connect.errors.generic';
  if (!Object.prototype.hasOwnProperty.call(ADS_ERROR_KEYS, code)) return 'connect.errors.generic';
  return ADS_ERROR_KEYS[code];
}
